import { useQuery } from '@tanstack/react-query';
import { requestMaterialApi } from '@entities/requestMaterial';

export const useGetEstimateSupplyRequestPositionList = () =>
    useQuery({
        ...requestMaterialApi.getPositionListQueryOptions(),
    });
